import Firebase from "firebase"

export const PRODUCTS_ENDPOINT = "https://products.tinymerch.com/products.json"

export const FUNCTIONS_ENDPOINT =
  "https://us-central1-tinymerch-36183.cloudfunctions.net/"

export const FIREBASE_CONFIG = {
  apiKey: "AIzaSyAit6VzLp1Rc05R9WCvZSg0tK6eqtLYEJs",
  authDomain: "tinymerch-36183.firebaseapp.com",
  databaseURL: "https://tinymerch-36183.firebaseio.com",
  projectId: "tinymerch-36183",
  storageBucket: "tinymerch-36183.appspot.com",
  messagingSenderId: "942379399140",
}

export const firebase = Firebase.initializeApp(FIREBASE_CONFIG)

export const functionsUrl =
  "https://us-central1-tinymerch-36183.cloudfunctions.net/"

export const imagesFirebase = Firebase.app().storage(
  "gs://images.tinymerch.com"
)



// WEBPACK FOOTER //
// ./src/constants.js